module.exports = __webpack_public_path__ + "img/pic5.8b9e19ca.jpg";